'use client';
import { useEffect } from 'react';

import { DefaultErrorFallback } from '@/components/ErrorBoundary/ErrorBoundary';
import useRollbar from '@/hooks/useRollbar';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const rollbar = useRollbar();

  useEffect(() => {
    if (rollbar)
      rollbar.error('Error caught by NextJs ErrorBoundary', error, { uri: window.location.href });
  }, [rollbar]);

  return <DefaultErrorFallback />;
}
